<template>
  <div>
    <h4 class="question _margin-bottom-30">What type of property do you have?</h4>

    <div class="row">
      <div class="col-xs-6 col-sm-4" v-for="p in propertyList" :key="p.name">
        <radio-button v-model="quote.propertyId" :value="p.id" @change="onChoose(p)" :error="$v.propertyId.$error"
          class="radio-icons">
          <img v-if="p.id == 3" src="../../../assets/Terraced_House.svg" class="center-block img-responsive" />
          <img v-else-if="p.id == 4" src="../../../assets/Semi-detached_House.svg"
            class="center-block img-responsive" />
          <img v-else-if="p.id == 5" src="../../../assets/Bungalow.svg" class="center-block img-responsive" />
          <img v-else-if="p.id == 7" src="../../../assets/Apartments.svg" class="center-block img-responsive" />
          <img v-else src="../../../assets/Detached_House.svg" class="center-block img-responsive" />
          {{ p.name }}
        </radio-button>
      </div>
    </div>

    <div class="row" v-if="$v.propertyId.validProperty == false">
      <div class="col-xs-12 text-center">
        <div class="alert alert-info">
          We are unable to provide Solar quotes for Flats and Maisonette property types
        </div>
      </div>
    </div>

    <div class="alert alert-danger _margin-top-20" v-if="error">
      <b>Error</b><br />
      {{ error }}
    </div>

    <div class="card-footer">
      <div class="col-xs-6">
        <uiv-btn @click="onBack">Back</uiv-btn>
      </div>

      <div class="col-xs-6 text-right">
        <uiv-btn type="primary" @click="onGoToQuestion('next')"
          :disabled="$v.propertyId.validProperty == false">Next</uiv-btn>
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'PropertyType',
  data() {
    return {
      error: null
    };
  },
  props: {
    $v: Object
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote,
      quoteSession: ({ session }) => session.quote_journey_session,
      propertyList: ({ lookups }) => lookups.esaPropertyTypes
    })
  },
  methods: {
    ...mapActions({
      goToQuestion: 'quote_questions/goToQuestion'
    }),
    async onChoose(p) {
      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Property Type' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Choose' });
      this.$store.dispatch('tracing/addAction', { name: 'Value', value: p.name });
      this.quote.propertyTypeName = p.name;
      this.quote.propertyId = p.id;

      await this.$store.dispatch('tracing/saveActions');
    },
    onBack() {
      this.goToQuestion({ type: 'prev' });
      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Property Type' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Back' });
      this.$store.dispatch('tracing/saveActions');
    },
    async onGoToQuestion(type) {
      this.$v.propertyId.$touch();
      this.error = null;
      if (this.$v.propertyId.$invalid) return;

      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Property Type' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Next' });
      await this.$store.dispatch('tracing/saveActions');

      const lastStep = await this.goToQuestion({ type });
      if (lastStep) {
        const error = await this.$store.dispatch('quote/newQuote', 'solar');
        this.error = error;
        if (!error) {
          this.$router.push({ name: 'quoteResults' });
        }
      }
    }
  },
  components: {
    RadioButton
  }
};
</script>

<style lang="scss">
.small {
  font-size: 12px;
}
</style>
